import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['leap', 'pragmatic', 'relax', 'blueprint'],
        'live-casino': ['pragmatic', 'ezugi'],
        virtuals: ['pragmatic', 'leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    complianceNew: true,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino', 'bingo'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'], // TODO: CONFIRM FOR PRICEDUP
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: false,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: false,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text: '#TOBEADDED', // TODO: ADD FOR PRICEDUP
        licence_number: '#TOBEADDED', // TODO: ADD FOR PRICEDUP
        licence_url: '#TOBEADDED', // TODO: ADD FOR PRICEDUP
        cookies_url: '#TOBEADDED', // TODO: ADD FOR PRICEDUP
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: {
        enabled: true,
        brand: 'PricedUp',
    },
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-56J5NRJS',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'PricedUp',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'kaching',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'PricedUp Events', // TODO: CONFIRM FOR PRICEDUP
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: true,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    usePaymentFormForUniverse: {
        type: 'paysafe',
        apiKey: 'T1QtNDQ4MzU0OkItcDEtMC02OGNhYzM1Zi0wLTMwMmQwMjE1MDA5MmFiZGE4YTM0YWE3NWE5MDk0MTVhYjZmNjI1ZjE0MzBlNTljMWNhMDIxNDIyZDVmNzAzOWE2MjA0YzBlZWNlM2FhZTY2NjI4OWEzMTk2MThmYjQ=',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1003450214',
            EUR: '',
        },
        openBanking: 'yaspa',
    },
    userTitleOptional: false,
    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        Accounts: 'Accounts-PricedUp/Overview',
        BackofficeReports: 'BackOfficeReports-PricedUp/DB-Casino',
        CasinoDashboard: 'CasinoDashboard-PricedUp/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-PricedUp/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-PricedUp/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-PricedUp/DailyKPI',
        RacecourseDashboard: 'Racecourse-PricedUp/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-PricedUp/TransactionsMainDashboard',
        AccountBalances: 'AccountBalances-PricedUp/AccountBalances',
        SRGDashboard: 'SRGDashboard-PricedUp/DBAverageStakes',
        RollingNetDeposits: 'RollingNetDeposits-PricedUp/RollingNetDeposits',
        BonusEngine: 'BonusEngine-PricedUp/CampaignLevel',
        LiveChat: 'LiveChat-PricedUp/LiveChatDashboard',
        CustomerRetention: 'CustomerRetention-PricedUp/OneYearRetention',
    },
};
